module.exports = __webpack_public_path__ + "img/mockup_delivery_260303.975470c0.png";